import { authApi } from './authApi';

// seal config
export const fetchSealConfig = async (): Promise<any> => {
  return await authApi.get('admin/seal_config/');
};

export const sealConfigCreate = async (payload: any) => {
  return await authApi.post('admin/seal_config/', payload);
};

export const editSealConfig = async (payload: any) => {
  return await authApi.patch(
    `admin/seal_config/${payload?.id}/`,
    payload?.body
  );
};
